import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import { BaseProvider } from './base-provider';

@Injectable()
export class ConsumerMoneyProvider extends BaseProvider {
	url: any;

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
		super();
	}

	purchaseCredit(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'consumerMoney/buy/' + params.business.Id ;

			this.storage.get('loginData').then((loginData) => {
				this.http.post(
					this.url,
					params.payment,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});       
	}	 	

	getBusinessActivity(params){	
	  	this.url = this.globals.dataUrl + 'consumerService/whiskey/' + this.globals.whiskeyId +
	  				 					  '/business/' + params.businessId + 
										  '/page/' + params.page +
										  '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})
  	}	

	getBusinessPurchases(params){	
	  	this.url = this.globals.dataUrl + 'consumerService/whiskey/' + this.globals.whiskeyId +
	  				 					  '/business/' + params.businessId + 
										  '/page/' + params.page +
										  '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})
  	}	

  	createOrder(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'consumerMoney/debit/' + params.BusinessId;

			this.storage.get('loginData').then((loginData) => {
				this.http.post(
					this.url,
					params,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});       
	}	  	
}



// WEBPACK FOOTER //
// ./src/providers/consumer-money-handler.ts